// src/services/BookReviewManager.js

import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/reviews`;

const BookReviewManager = {
  // Add a new review (sending data as query params)
  async addReview(userId, bookId, rating, review = "") {
    const params = new URLSearchParams();
    params.append("userId", userId);
    params.append("bookId", bookId);
    params.append("rating", rating);
    if (review) params.append("review", review);

    const response = await axios.post(`${BASE_URL}/add?${params.toString()}`);
    return response.data.responseData;
  },

  // Get all reviews for a specific book
  async getReviewsByBook(bookId) {
    const response = await axios.get(`${BASE_URL}/book/${bookId}`);
    return response.data.responseData;
  },

};

export default BookReviewManager;
